module.exports = __webpack_public_path__ + "static/media/hoiRed.dcabd5cd.svg";